/* eslint-disable-next-line no-unused-vars,no-global-assign,no-undef,camelcase */
const GroupEach = function (num, context, options) {
  let out = '';
  let subcontext = [];
  let i;
  if (context && context.length > 0) {
    for (i = 0; i < context.length; i++) {
      if (i > 0 && i % num === 0) {
        out += options.fn(subcontext);
        subcontext = [];
      }
      subcontext.push(context[i]);
    }
    out += options.fn(subcontext);
  }
  return out;
};

module.exports = GroupEach;



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_ce_v2/package/src/js/helpers/group-each.js